import type { MiscellaneousMasterDataItem } from "@/lib/types/miscellaneous";

const MISC_KEY_TO_ID: Record<string, number> = {
  ADDITIONAL_DRIVER: 1,
  CHILD_SEAT: 2,
  EXTRA_100_KM: 3,
  HAND_TROLLY: 4,
  SNOW_COVER: 12,
  additional_driver: 1,
  baby_seat_rear: 2,
  baby_seat_forward: 2,
  child_booster_seat: 2,
  snow_pass: 12,
};

export function getMiscellaneousId(key: string): number | undefined {
  return MISC_KEY_TO_ID[key];
}

export function buildExtraMiscellaneousIds(
  addOns: MiscellaneousMasterDataItem[],
  quantities: Record<string, number>,
): number[] {
  const ids: number[] = [];

  for (const item of addOns) {
    const quantity = quantities[item.key] ?? 0;
    if (quantity <= 0) {
      continue;
    }

    const id = getMiscellaneousId(item.key);
    if (id === undefined) {
      continue;
    }

    for (let index = 0; index < quantity; index += 1) {
      ids.push(id);
    }
  }

  return ids;
}
